<!--
工单列表
-->
<template>
	<div>
		<div class="item-container" v-for="item in list" :key="item.sheetId">
			<!-- 状态 -->
			<div class="flex-col-center mb10">
				<el-tag type="warning" v-if="item.status == 0">待分配</el-tag>
				<el-tag type="warning" v-else-if="item.status == 1">待接单</el-tag>
				<el-tag v-else-if="item.status == 2">处理中</el-tag>
				<el-tag v-else-if="item.status == 3">待验收</el-tag>
				<el-tag type="success" v-else-if="item.status == 4">已完成</el-tag>
				<el-tag type="danger" v-else-if="item.status == 5">已撤消</el-tag>
				<el-tag type="danger" v-else>异常</el-tag>
				<el-tag v-if="item.isAutoDistribute === '1'" type="success" class="ml10">自动分配</el-tag>
				<el-tag v-if="item.isFocus === '1'" type="danger" class="ml10">验收不通过</el-tag>
				<div class="item-title text-hidden">{{ item.sheetTitle }}</div>
				<div class="text-hidden" style="margin-left: 28px">
					<span class="mr20">工单编号：{{ item.sheetNumber }}</span>
					<span>发起客户: {{ item.adminUserName }}</span>
					<span style="margin: 0 10px">|</span>
					<span>发起人：{{ item.clientUserName }}</span>
					<span style="margin: 0 10px">|</span>
					<span>发起时间：{{ item.startTime }}</span>
				</div>
			</div>
			<el-row class="item-content" :gutter="20">
				<el-col :lg="item.expectedCompleteTime ? 4 : 6" :md="6" :sm="12" :xs="12">
					<div>联系人: {{ item.contactUserName }}</div>
					<div>联系电话：{{ item.contactTel }}</div>
				</el-col>
				<el-col :lg="item.expectedCompleteTime ? 5 : 6" :md="6" :sm="12" :xs="12">
					<div>处理人：{{ item.receiveUserName || '--' }}</div>
					<div class="text-hidden">处理人电话：{{ item.receiveUserPhone || '--' }}</div>
				</el-col>
				<el-col :lg="3" :md="6" :sm="12" :xs="12">
					<div>期望完成时间</div>
					<el-tooltip :content="item.hopeCompleteTime" placement="top">
						<div class="work-time text-hidden">{{ item.hopeCompleteTime || '--' }}</div>
					</el-tooltip>
				</el-col>
				<el-col :lg="3" :md="6" :sm="12" :xs="12" v-if="item.expectedCompleteTime">
					<div>预计完成时间</div>
					<el-tooltip :content="item.expectedCompleteTime" placement="top">
						<div class="work-time text-hidden">
							{{ item.expectedCompleteTime || '--' }}
						</div>
					</el-tooltip>
				</el-col>
				<el-col :lg="3" :md="6" :sm="12" :xs="12">
					<div>工单耗时</div>
					<el-tooltip :content="item.sheetUseTime" placement="top">
						<div class="work-time text-hidden">{{ item.sheetUseTime }}</div>
					</el-tooltip>
				</el-col>
				<el-col :lg="3" :md="6" :sm="12" :xs="12">
					<div>状态</div>
					<div style="color: #e6a23c" v-if="item.status == 0">待分配</div>
					<div style="color: #e6a23c" v-else-if="item.status == 1">待接单</div>
					<div style="color: #409eff" v-else-if="item.status == 2">处理中</div>
					<div style="color: #409eff" v-else-if="item.status == 3">待验收</div>
					<div style="color: #67c23a" v-else-if="item.status == 4">已完成</div>
					<div style="color: #f56c6c" v-else-if="item.status == 5">已撤消</div>
					<div style="color: #f56c6c" v-else>异常</div>
				</el-col>
				<el-col :lg="3" :md="6" :sm="12" :xs="12">
					<div>操作</div>
					<div class="flex-col-center content-btns">
						<!-- <el-tooltip content="查看工单" placement="top">
              <img src="@/assets/images/home_icon_ck.png" v-if="btns['handle-order']" @click="jump(item)" />
            </el-tooltip>
            <el-tooltip content="撤销工单" placement="top">
              <img src="@/assets/images/home_icon_de.png" v-if="btns['del-order'] && item.status == '0'"
                @click="cancelOrder(item)" />
            </el-tooltip> -->
						<template>
							<el-button type="primary" size="mini" plain v-if="btns['handle-order']" @click="jump(item)">
								查看
							</el-button>
						</template>
						<template>
							<el-button type="primary" size="mini"
								v-if="btns['del-order'] && (item.status == '0' || item.status == '1') && item.isOperationSheet == '1'"
								@click="cancelOrder(item)">
								撤单
							</el-button>

							<el-button type="primary" size="mini" v-if="item.status == '3' && item.isOperationSheet == '1'" @click="openSubmit(item)">
								验收
							</el-button>
						</template>
					</div>
				</el-col>
			</el-row>
			<div class="item-line"></div>
			<div class="content-val">问题详情：{{ item.questions[0].questions }}</div>
		</div>
		<!-- 验收工单 -->
		<acceptance-order @refresh="refresh" ref="acceptanceOrder"></acceptance-order>
	</div>
</template>

<script>
	import AcceptanceOrder from '@/components/WorkOrder/AcceptanceOrder.vue'
	export default {
		props: {
			list: {
				type: Array,
				default: () => {
					return []
				}
			},
			btns: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		components: {
			AcceptanceOrder
		},
		data() {
			return {}
		},
		computed: {
			userType() {
				return this.$store.state.user.userType
			}
		},
		watch: {},
		mounted() {},
		methods: {
			// 撤销工单
			cancelOrder(data) {
				this.$confirm('此操作将撤销该工单, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						this.$api.order.cancelSheet(data.sheetId).then(({
							data
						}) => {
							if (data.code == 200) {
								this.$notify.success({
									title: '提示',
									message: '撤销成功'
								})
								this.refresh(1)
							}
						})
					})
					.catch(() => {})
			},
			// 验收工单
			openSubmit(item) {
				this.$refs.acceptanceOrder.open(item)
			},
			refresh(status) {
				this.$emit('refresh', status)
			},

			// 跳转工单详情
			jump(data) {
				let routeData = this.$router.resolve({
					path: '/workOrderDetail',
					query: {
						id: data.sheetId
					}
				})
				window.open(routeData.href, '_blank');
			}
		}
	}
</script>
<style lang="scss" scoped>
	.item-container {
		padding: 10px 25px 5px 10px;
		margin-bottom: 10px;
		background: #f7f8ff;
		border-radius: 10px;
		box-sizing: border-box;
		border-left: 13px solid #f7f8ff;
		transition: all 0.2s;
		font-size: 14px;
		font-weight: 500;
		color: rgba(41, 48, 82, 0.7);
		line-height: 30px;

		&:hover {
			border-color: rgb(54, 130, 255);
		}

		&:last-child {
			margin-bottom: 0;
		}

		.item-title {
			margin-left: 12px;
			font-size: 16px;
			color: #293052;
		}

		.item-content {
			.work-time {
				font-size: 20px;
				font-family: DIN;
				font-weight: bold;
				color: #293052;
				opacity: 0.7;
			}

			.content-btns>img {
				width: 23px;
				height: 23px;
				object-fit: contain;
				margin-right: 19px;
				cursor: pointer;
				opacity: 0.5;

				&:last-child {
					margin-right: 0;
				}

				&:hover {
					opacity: 1;
				}
			}
		}

		.content-val {
			line-height: 25px;
			font-size: 14px;
			font-weight: 500;
			color: rgba(41, 48, 82, 0.7);
			// overflow: hidden;
			// white-space: nowrap;
			// text-overflow: ellipsis;
			// text-overflow: -o-ellipsis-lastline;
			// overflow: hidden;
			// text-overflow: ellipsis;
			// display: -webkit-box;
			// -webkit-line-clamp: 2;
			// -webkit-box-orient: vertical;
		}

		.item-line {
			height: 1px;
			margin: 10px 0 10px 0;
			border-bottom: 1px dashed #293052;
			opacity: 0.15;
		}
	}
</style>
